<script>
  export default {
    data: function () {
      return {
        isOpen: false
      };
    },
    methods: {
      toggle: function () {
        this.isOpen = !this.isOpen;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// assets/js/components/header/nav-bar/TheSubmenu.vue